import './perf/emit-event'
import './perf/emit'
import 'file?name=[name].[ext]!lodash?'
import 'file?name=[name].[ext]!./perf.html?'
import 'file?name=[name].[ext]!benchmark?'



// WEBPACK FOOTER //
// ./test/perf-test.js